export default __webpack_public_path__ + "content/media/imgfondo.1d3f7191.png";